import { Component, ViewChild, ElementRef, Input } from '@angular/core';
import { Router } from '@angular/router';
import {
  APIResponse,
  productList,
} from '@AppRoot/shared/models/api-response.interface';
import { CartItems } from '@AppRoot/shared/models/common.interface';
import { SharedService } from '@AppRoot/shared/services/shared.service';
import { Subscription } from 'rxjs';
import { GlobalUtilityService } from 'src/app/core/services/global-utility.service';

@Component({
  selector: 'app-category-listing',
  templateUrl: './category-listing.component.html',
  styleUrls: ['./category-listing.component.scss'],
})
export class CategoryListingComponent {
  @Input() title: string = '';
  @Input() cardsData: productList[] = [];
  @Input() backgroundColor: string = '#ffffff';
  @Input() cardLoaded: boolean = false;
  showSuccess: boolean = false;
  showQuantityExceedError: boolean = false;

  private subscription: Subscription = new Subscription();

  errorMessage: string =
    'No more quantity available for this product. It will be available soon!';

  constructor(
    private _globalUtilityService: GlobalUtilityService,
    private _sharedService: SharedService,
    private _router: Router
  ) {}

  ngOnInit() {}

  @ViewChild('scrollContainer', { read: ElementRef })
  scrollContainer!: ElementRef;

  scrollLeft(element: any) {
    element.scrollLeft -= 200;
  }

  scrollRight(element: any) {
    element.scrollLeft += 200;
  }

  redirectToProduct(slug?: string) {
    console.log(slug);
    if (slug) this._globalUtilityService.navigateToPath(`products/${slug}`);
  }

  async addProductToCart(data: productList, navigate?: boolean) {
    this._globalUtilityService.showLoader();
    if (!data.product_size_id || !data.id) {
      return;
    }
    if (!data?.quantity) {
      return;
    }

    this._sharedService
      .updateCart(data.product_size_id, data.id, 1, 1)
      .subscribe({
        next: (res: any) => {
          if (res) {
            this._globalUtilityService.hideLoader();
            if (!navigate) {
              setTimeout(() => {
                this.showSuccess = false;
              }, 1000);
              this._sharedService.setCartOpen(true);
            } else {
              this._router.navigate(['/checkout']);
            }
          } else {
            this._globalUtilityService.showToast(
              'error',
              'Product cannot added to cart'
            );
          }
        },
        error: (error: any) => {
          this._globalUtilityService.showToast(
            'error',
            'Product cannot added to cart'
          );
          console.log(error);
        },
      });
  }

  getDiscountPercentage(unitPrice: number, discountedPrice: number): number {
    return Math.round(((unitPrice - discountedPrice) / unitPrice) * 100);
  }

  buyNow(data: productList) {
    let isAddedToCart: CartItems;
    this._globalUtilityService.showLoader();
    if (data && data.product_size_id) {
      this.subscription.add(
        this._sharedService.getCartItems().subscribe({
          next: (res: APIResponse) => {
            const cartItems = res.data?.cart_items;
            if (cartItems && cartItems.length > 0) {
              cartItems.map((d: CartItems) => {
                if (d.product_size_id == data?.product_size_id) {
                  data.quantity = d.quantity;
                  isAddedToCart = d;
                }
              });
            }

            if (!isAddedToCart?.quantity || isAddedToCart?.quantity < 1) {
              this.addProductToCart(data, true);
            } else {
              this._globalUtilityService.hideLoader();
              this._router.navigate(['/checkout']);
            }
          },
        })
      );
    }
  }

  parseJSON(data: string | undefined) {
    if (typeof data !== 'string') {
      return data;
    }

    if (!data || data === 'null' || data === 'undefined') {
      return {};
    }
    return JSON.parse(data);
  }
}
